import { Drawer, Image, Layout, Radio } from 'antd';
import React from 'react';
import { Images } from '../../../controller/Images';
import { CloseOutlined } from '@ant-design/icons';
import { usecandidateSidebarStore } from '../../../store/candidateSidevarReducer';
const { Sider } = Layout;
const TestSidebar = ({ drawerVisible, toggleDrawer }) => {
  const logo=localStorage.getItem('candidate_logo')
  const SidebarMenuItem = () => {
    // const [totalAnswer, setTotalAnswer] = useState(0);
    // const [totalQuestion, setTotalQuestion] = useState(0);
    const { menuItem, menuItemValue } = usecandidateSidebarStore(
      (state) => state
    );
   
  const getTotalQuestion = () => {
    return menuItem?.reduce((acc, item) => acc + (item?.totalquestion || 0), 0) || 0;
  };

  const getTotalAnswer = () => {
    return menuItem?.reduce((acc, item) => acc + (item?.totalanswer || 0), 0) || 0;
  };

    return (
      <div className='d-flex flex-column gap-3 mt-5 custom-font-family-poppins'>
        <div className='d-flex justify-content-evenly align-items-center  cadidate-status-bar '>
          <span>Questions</span>
          <div className='d-flex gap-1 align-items-center'>
            <span>
              {getTotalAnswer()} / {getTotalQuestion()}
            </span>
            <span className='sidebar-item-background-color text-color-custom  percentage'>
              {Math.round((getTotalAnswer() / getTotalQuestion()) * 100)} %
            </span>
          </div>
        </div>
        {menuItem?.map((val, index) => (
          <div
            key={index}
            className={`w-100 rounded-3 p-2 text-black text-capitalize ${
              menuItemValue === index && 'sidebar-item-background-color'
            } ${val?.radio ? 'fw-bolder' : 'fw-semibold'}`}
          >
            <Radio
              className={`custom-radio w-100 ${
                menuItemValue === index && 'text-color-custom'
              }`}
              checked={val?.complete == 100 ? true : false}
            >
              <div className='d-flex justify-content-evenly align-items-center custom-font-family-poppins menu-item-list'>
                <span>{val.name}</span>
                <span className='text-center text-color-custom section-status'>
                  {val?.totalanswer} / {val?.totalquestion}
                </span>
              </div>
            </Radio>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <Sider
        className='bg-white border-end p-4 d-flex flex-column d-lg-block d-sm-none responsive-sidebar '
        // breakpoint='md'
        // collapsedWidth={0}
        // collapsed={sidebar}
        // onCollapse={setSidebar}
      >
        <div className='w-100 d-flex justify-content-center align-items-center'> 
               <Image
                 src={logo||Images.logo}
                 alt=''
                 className='logo'
                 width={'auto'}
                 height={50}
                 preview={false}
               />
               </div>
        <SidebarMenuItem />
      </Sider>
      <Drawer
        title=''
        placement='left'
        closable={false}
        onClose={toggleDrawer}
        visible={drawerVisible}
      >
       <CloseOutlined
                   className='d-flex align-items-end justify-content-end'
                   onClick={() => toggleDrawer()}
                 />
                <div className='w-100 d-flex justify-content-center align-items-center'> 
               <Image
                 src={logo||Images.logo}
                 alt=''
                 className='logo'
                 width={'auto'}
                 height={50}
                 preview={false}
               />
               </div>
        <SidebarMenuItem />
      </Drawer>
    </>
  );
};

export default TestSidebar;
